import { nodeApi } from "@/redux/api/nodeApi";

const inviteApi = nodeApi.injectEndpoints({
  endpoints: (builder) => ({
    // Post brand details
    inviteMember: builder.mutation({
      query: (payload) => ({
        url: `/team/invite`,
        method: "POST",
        body: payload,
      }),
    }),
    getTeamData: builder.query({
      query: (id) => ({
        url: `/team/${id}`,
        method: "GET",
      }),
    }),


   
  }),
});

export const {
  useInviteMemberMutation,
  useGetTeamDataQuery

} = inviteApi;
